import { financeKeys } from '../../../modules/json/financeKeys';

/**
 * Helper function to get the real key we should send to CW. Sometimes we have to use testing keys like PREPROD_HP before we push things live, so instead of changing all the keys in the code to PREPROD_HP, we continue to use HP in the code, but in the .env file we add HP=PREPROD_HP, and then run php artisan json:build. This will output a json file in /resources/assets/js/modules/json which has the lookup object. We then reference that object here, so financeKeys.HP would be equal to PREPROD_HP, which is the key we send to CW.
 *
 * @param {string} key
 */
export default function (key) {
    return (financeKeys[key]) ? financeKeys[key] : key;
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/finance/GetActualKeyFromKey.js